import IconExpandLess from '@fortuneo/ui-icons/general/IconExpandLess'
import { isBrowser } from '@utils/is-browser'
import { clsx } from 'clsx/lite'
import React, { type FC, useCallback, useEffect, useState } from 'react'
import { animateScroll as scroll } from 'react-scroll'

import { useIsIframe } from '../../../plugins/gatsby-plugin-espace-client'

export const GoUpButton: FC = () => {
  const [isVisible, setIsVisible] = useState(false)
  const isIframe = useIsIframe()

  const onFabClick = useCallback(() => {
    scroll.scrollToTop()
  }, [])

  useEffect(() => {
    if (!isBrowser || isIframe) return

    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <button
      type="button"
      className={clsx(
        'fixed bottom-5 right-5 z-[1000] flex h-12 w-12 items-center justify-center rounded-full border border-border-default bg-background-default transition-all duration-200',
        isVisible ? 'opacity-100' : 'opacity-0'
      )}
      onClick={onFabClick}
    >
      <IconExpandLess />
    </button>
  )
}
